$('.Tabs').each(function(i, tab) {
    const tabRoot = $(this);
    const tabTrigger = '.TabTrigger';
    const tabContent = '.TabContent';
    const findTabTrigger = tabRoot.find(tabTrigger);
    const findTabContent = tabRoot.find(tabContent);

    findTabTrigger.attr('aria-selected', false);

    findTabTrigger.eq(0).addClass('__active').attr('aria-selected', true);
    findTabContent.eq(0).addClass('__active');

    findTabTrigger.click(function(e) {
        e.preventDefault();
        const dataSet = $(this).data('set');

        tabRoot.find(tabTrigger + '.__active').attr('aria-selected', false).removeClass('__active');
        $(this).attr('aria-selected', true).addClass('__active');

        tabRoot.find(tabContent + '.__active').removeClass('__active');
        tabRoot.find(tabContent + '[data-set="' + dataSet + '"]').addClass('__active');
        
    });
});
